import { useEffect } from "react";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { getEmbeddingsModelsAction } from "../redux/actions";
import {
  selectDisabled,
  selectInputValues,
  selectLoading,
  selectModels,
  selectSelectedModel
} from "../redux/selectors";
import { setIsDisabled, setModelsAction, } from "../redux/slice";


export const useEmbeddings = () => {
  const dispatch = useAppDispatch();
  const models = useAppSelector(selectModels);
  const selectedModel = useAppSelector(selectSelectedModel);
  const inputValues = useAppSelector(selectInputValues);
  const isDisabled = useAppSelector(selectDisabled);
  const isLoading = useAppSelector(selectLoading);

  useEffect(() => {
    dispatch(getEmbeddingsModelsAction())
      .unwrap()
      .then((response) => {
        dispatch(setModelsAction(response));
      });
  }, []);

  useEffect(() => {
    dispatch(setIsDisabled());
  }, [inputValues, selectedModel]);

  return {
    models,
    inputValues,
    selectedModel,
    isDisabled,
    isLoading,
  };
};